<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择"
      width="800px"
      top="5vh"
      @close="closePage">
    <table-select 
        ref="tableSelect" 
        :filter="filter" 
        :columns="columns" 
        module="basic" 
        url="rtProcess" 
        @select="selectProcedure">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="工序编号">
            <el-input v-model.trim="filter.processNo" placeholder="请输入工序编号" clearable/>
          </el-form-item>
          <el-form-item label="工序名称">
            <el-input v-model.trim="filter.processName" placeholder="请输入工序名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          routeId: "",
        },
        columns: [
          {
            title: "工序编号",
            key: "processNo",
            width: 140,
            align: "center",
          },
          {
            title: "工序名称",
            key: "processName",
          },
          {
            title: "工序状态",
            key: "statusName",
            width: 100,
            align: "center",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open(id) {
        console.log(id);
        this.dialogVisible = true;
        if (id) {
          this.filter.routeId = id;
        }
        this.$nextTick(()=>{
          this.$refs.tableSelect.loadData();
        });
      },

      selectProcedure(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      closePage() {
        this.$nextTick(() => {
          this.filter.routeId = "";
        });
      },
    },
  };
</script>
